const EXTERNAL_LINK = {
  SOCIAL_MEDIA: {
    FACEBOOK: "https://www.facebook.com/mozaik021.rs/",
    INSTAGRAM: "https://www.instagram.com/mozaik021_travel/"
  }
};

export default EXTERNAL_LINK;
